
























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BudgetExpense from "@/models/porposal/budgetExpense.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import UserService from "../../../services/user.service";
import { PermissionValue } from "../../../enums/PermissionValue";
@Component
export default class BudgetExpenseTableComponent extends GenericBTable<
  BudgetExpense
> {
  created() {
    this.permissionValue = PermissionValue.GASTOPRESUPUESTO;
    this.tableConfig.controller = "BudgetExpense";
    this.tableConfig.actions.customTemplate = true;
    this.formatColumns();
  }
  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let index = new BTableColumn("index", "table.index", true);
    this.tableConfig.insertColumns(name,index);
  }

  verOpciones(row: BudgetExpense) {
    this.$router.push(`/budget-expense/${row.id}/budget-item`);
  }
}
